(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95,304,7364],{

/***/ 21956:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propertydetails/[property]",
      function () {
        return __webpack_require__(72003);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Auth_Steps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Auth/useAuth.ts

var STEP;
(function(STEP) {
    STEP[STEP["NEXT"] = 1] = "NEXT";
    STEP[STEP["REGISTER"] = 2] = "REGISTER";
    STEP[STEP["LOGIN"] = 3] = "LOGIN";
})(STEP || (STEP = {}));
var useAuth = function() {
    var ref = (0,react.useState)(STEP.NEXT), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var onRegister = function() {
        setEmail("");
        setStep(STEP.NEXT);
    };
    var onNext = function(email) {
        setEmail(email);
        setStep(STEP.REGISTER);
    };
    var onLogin = function() {
        setStep(STEP.LOGIN);
    };
    return {
        step: step,
        onNext: onNext,
        email: email,
        onLogin: onLogin,
        onRegister: onRegister
    };
};
/* harmony default export */ var Auth_useAuth = (useAuth);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/Auth/Steps.tsx




var Next = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7066), __webpack_require__.e(8786), __webpack_require__.e(9491), __webpack_require__.e(7704)]).then(__webpack_require__.bind(__webpack_require__, 57704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57704)
            ];
        }
    },
    suspense: true
});
var Register = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7066), __webpack_require__.e(8786), __webpack_require__.e(9491), __webpack_require__.e(3568), __webpack_require__.e(3817)]).then(__webpack_require__.bind(__webpack_require__, 51945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51945)
            ];
        }
    },
    suspense: true
});
var Login = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7066), __webpack_require__.e(8786), __webpack_require__.e(9491), __webpack_require__.e(100)]).then(__webpack_require__.bind(__webpack_require__, 30100));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30100)
            ];
        }
    },
    suspense: true
});
var Steps = function() {
    var ref = Auth_useAuth(), step = ref.step, onNext = ref.onNext, email = ref.email, onLogin = ref.onLogin, onRegister = ref.onRegister;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full",
        children: step === STEP.NEXT ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Next, {
                    onLogin: onLogin,
                    onNext: onNext
                })
            })
        }) : step === STEP.REGISTER ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Register, {
                    onLogin: onLogin,
                    email: email
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                    onRegister: onRegister
                })
            })
        })
    });
};
/* harmony default export */ var Auth_Steps = (Steps);


/***/ }),

/***/ 96136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var VerificationSteps = function() {
    // const router = useRouter();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex justify-start items-start gap-4 flex-col pb-2",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-sm",
                    children: "A confirmation message has been sent to your email."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Verify your account by clicking the link. Please check spam if not found."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "After verifying, refresh the page for updates."
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VerificationSteps);


/***/ }),

/***/ 72003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Auth_Steps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(304);
/* harmony import */ var _components_VerificationSteps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96136);
/* harmony import */ var _utils_apiClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77364);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _context_useStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80094);











var ImageSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7677), __webpack_require__.e(8180)]).then(__webpack_require__.bind(__webpack_require__, 98644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98644)
            ];
        }
    },
    suspense: true
});
var Details = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(5673)]).then(__webpack_require__.bind(__webpack_require__, 91847));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91847)
            ];
        }
    },
    suspense: true
});
var Basic = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4617), __webpack_require__.e(2536)]).then(__webpack_require__.bind(__webpack_require__, 29612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29612)
            ];
        }
    },
    suspense: true
});
var Contact = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(5675), __webpack_require__.e(2949)]).then(__webpack_require__.bind(__webpack_require__, 81155));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81155)
            ];
        }
    },
    suspense: true
});
var SimilarProp = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9402).then(__webpack_require__.bind(__webpack_require__, 99402));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99402)
            ];
        }
    },
    suspense: true
});
var PropertyDetail = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref = (0,_context_useStore__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), auth = ref.auth, setDialog = ref.setDialog;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), step = ref1[0], setStep = ref1[1];
    var onClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _utils_apiClient__WEBPACK_IMPORTED_MODULE_6__/* .apiClient.post */ .x.post("/api/v1/auth/email-verify")
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.ok) {
                            setStep(2);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var track = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_apiClient__WEBPACK_IMPORTED_MODULE_6__/* .apiClient.post */ .x.post("/api/v1/track/property", {
                            url: "/propertydetails/" + router.query.property,
                            price: props.prop.ListPrice,
                            mls: props.prop.ListingKey,
                            media: props.prop.Media.length === 0 ? "/images/fallback.webp" : props.prop.Media[0].MediaURL
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        router.query.property
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (auth.login) {
            if (auth.role === "user") {
                track();
            }
        }
    }, [
        auth.login,
        auth.role,
        track
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City, " - BungalowFinder ")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City, " - BungalowFinder")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.prop.PublicRemarks ? props.prop.PublicRemarks.replace(/"/g, "").slice(0, 160) : "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City, " is a beautiful luxury Bungalow for Sale in ").concat(props.prop.City, ". It contains ").concat(props.prop.BedroomsTotal, " Bedrooms,").concat(props.prop.BathroomsTotalInteger, " bathrooms,").concat(props.prop.ParkingTotal, " parking spaces")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://bungalowfinder.ca/propertydetails/".concat(props.prop.slug)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City, " - BungalowFinder")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.prop.PublicRemarks ? props.prop.PublicRemarks.slice(0, 160) : "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City, " is a beautiful luxury Bungalow for Sale in ").concat(props.prop.City, ". It contains ").concat(props.prop.BedroomsTotal, " Bedrooms,").concat(props.prop.BathroomsTotalInteger, " bathrooms,").concat(props.prop.Tot_park_spcs)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        itemProp: "image",
                        content: props.prop._type === "rets" ? "https://api.bungalowfinder.ca/cdn/images/".concat(props.prop.ListingKey, "/photo_1.png") : ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + ", " + props.prop.City, " - BungalowFinder")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + ", " + props.prop.City, " - BungalowFinder")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: props.prop.PublicRemarks ? props.prop.PublicRemarks.slice(0, 160) : "".concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + ", " + props.prop.City, " is a beautiful luxury Bungalow for Sale in ").concat(props.prop.City, ". It contains ").concat(props.prop.BedroomsTotal, " Bedrooms,").concat(props.prop.BathroomsTotalInteger, " bathrooms,").concat(props.prop.ParkingTotal, " parking spaces")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://BungalowFinder.ca/images/ogimg.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '[{\n              "@context": "https://schema.org",\n              "@type": "RealEstateListing",\n              "url": "https://bungalowfinder.ca/propertydetails/'.concat(props.prop.slug, '",\n              "name": "').concat(props.prop.BedroomsTotal, " Bedrooms Bungalow for sale in ").concat(props.prop.City, '",\n              "description": "').concat(props.prop.PublicRemarks.replaceAll(/(?:\r\n|\r|\n)/g, " ").replace(/\\/g, " ").replace(/"/g, " "), '",\n              "image": "').concat(props.prop._type === "rets" ? "https://api.bungalowfinder.ca/cdn/images/".concat(props.prop.ListingKey, "/photo_1.png") : "", '",\n              "address": {\n                "@type": "PostalAddress",\n                "streetAddress":"').concat(props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix, '" ,\n                "addressLocality":"').concat(props.prop.City, '" ,\n                "addressRegion": "Ontario",\n                "postalCode": "').concat(props.prop.PostalCode, '",\n                "addressCountry": "CA"\n              },\n              "geo": {\n                "@type": "GeoCoordinates",\n                "latitude": ').concat(props.prop.Lat, ',\n                "longitude": ').concat(props.prop.Lng, '\n              },\n              "price": "$').concat(props.prop.ListPrice, '",\n              "priceCurrency": "CAD",\n              "propertyType": "Bungalow",\n              "numberOfBedrooms": ').concat(props.prop.BedroomsTotal, ',\n              "numberOfBathrooms": ').concat(props.prop.BathroomsTotalInteger, ',\n              "availability": "https://schema.org/InStock",\n              "agent": {\n                "@type": "Person",\n                "name": "Tariq Janjua",\n                "telephone": "416-828-7773",\n                "email": "info@bungalowfinder.ca"\n              }\n            }]')
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "relative w-full h-full",
                children: [
                    auth.login !== true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full items-center flex justify-center top-20 z-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-center bg-white md:px-10 md:py-8 items-center drop-shadow-xl ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "md:flex hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Steps__WEBPACK_IMPORTED_MODULE_4__["default"], {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-center gap-4 p-3 md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-normal",
                                            children: "Please Sign Up To View Property"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function() {
                                                setDialog({
                                                    open: true,
                                                    closable: true
                                                });
                                            },
                                            className: "bg-primary text-white w-fit px-4 py-2",
                                            children: "Sign Up"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    auth.login === true && auth.verify === false && props.prop.Lock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full items-center flex justify-center top-20 z-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-center bg-white md:px-10 md:py-8 items-center drop-shadow-xl ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col text-center items-center gap-4 max-w-lg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: " text-base text-primary md:text-lg font-normal",
                                        children: "Real Estate Board Requires to Verify This Email to View this Property"
                                    }),
                                    step === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: onClick,
                                        className: "bg-primary text-white py-2 px-4",
                                        children: "Verify Now"
                                    }) : step === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VerificationSteps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[300px] w-full bg-gray-100 animate-pulse"
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                                    className: "relative w-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full h-full \n                  ".concat(!auth.login ? "blur" : auth.login && !auth.verify && props.prop.Lock ? "blur" : "", "\n                    "),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageSlider, {
                                            Media: props.prop.Media
                                        }, props.prop.ListingKey)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col md:flex-row gap-2 container mx-auto py-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex-1 flex flex-col gap-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-[300px] w-full bg-gray-100 animate-pulse"
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Basic, {
                                                    data: props.prop
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Details, {
                                                    data: props.prop
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "md:top-20 md:sticky h-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-[300px] w-full bg-gray-100 animate-pulse"
                                            }),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Contact, {
                                                mls: props.prop.ListingKey,
                                                address: props.prop.UnparsedAddress ? props.prop.UnparsedAddress : props.prop.StreetNumber + " " + props.prop.StreetName + " " + props.prop.StreetSuffix + " " + props.prop.City
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "py-5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                                    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[300px] w-full bg-gray-100 animate-pulse"
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SimilarProp, {
                                        similarProp: props.similar
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PropertyDetail);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7066,9774,2888,179], function() { return __webpack_exec__(21956); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);